import script from "./ParentComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./ParentComponent.vue?vue&type=script&setup=true&lang=ts"

import "./ParentComponent.vue?vue&type=style&index=0&id=438ec5f8&lang=scss"

const __exports__ = script;

export default __exports__